import {
  Box,
  useColorModeValue,
  Flex,
  Image,
  Text,
  Divider,
} from "@chakra-ui/react";
import subs from "../../assets/subscription.png";
import heart from "../../assets/heart.png";
import know from "../../assets/know.png";
import uss from "../../assets/uss.png";
import bgbox from "../../assets/boxBg.png";
import crown from "../../assets/crown.png";
import { AiFillCaretRight } from "react-icons/ai";
import { BsCircleFill } from "react-icons/bs";

export default function TryPlus() {
  return (
    <Box py={10} px={10} textAlign={"left"} mb={20}>
      <Flex w={"100%"} flexDirection={{ md: "row", base: "column-reverse" }}>
        <Box w={"40%"} pt={15}>
          <Image
            src={heart}
            w={20}
            borderRadius={50}
            ml={12}
            mb={-10}
            mt={10}
          />
          <Text
            color={"#3C375F"}
            fontWeight={"extrabold"}
            fontSize={60}
            lineHeight={1}
          >
            Membership
            <br /> Prices & Plans
          </Text>
          <Text
            lineHeight={1}
            fontSize={21}
            mt={2}
            color={"#372449"}
            fontWeight={500}
          >
            Select the plan that best meets your needs.
            <br /> Unleash all your gifting needs with the
            <br /> power of Wishfy
          </Text>
          <Image src={know} alt="error" mt={5} w={"34%"} />
        </Box>
        <Box w={"60%"}>
          <Image src={subs} alt="image Preview" w={"100%"} />
        </Box>
      </Flex>
      <Flex
        border={"1px solid #707070"}
        borderRadius={20}
        bg={"#2C2E43"}
        color={"white"}
        px={5}
        alignItems={"center"}
        h={250}
        gap={8}
        mt={10}
      >
        <Box w={"22%"} h={"full"} py={5}>
          <Text fontSize={"34px"} fontWeight={"bold"}>
            Select Best
          </Text>
          <Text fontSize={"16px"} mt={5} color={"gray.400"}>
            Lorem ipsum is placeholder text commonly used in the graphic, print
            ...
          </Text>
        </Box>
        <Box w={"22%"} h={"full"} py={5}>
          <Flex alignItems={"baseline"}>
            <Text mt={6} fontSize={"24px"} fontWeight={"semibold"}>
              Individuals Plan
              <br />
              <Flex alignItems={"center"} fontSize={"14px"}>
                Know more <AiFillCaretRight color="#48f542" />
              </Flex>
            </Text>
            <Image src={uss} alt="error" w={14} />
          </Flex>
          <Divider border={"1px solid gray"} w={"95%"} mt={2} mb={2} />
          <Flex flexDirection={"column"}>
            <Text fontSize={"14px"} fontWeight={"semibold"}>
              Rs.149 Monthly
            </Text>
            <Text fontSize={"14px"} fontWeight={"semibold"}>
              Rs.1,490 Annually
            </Text>
          </Flex>
          <Text fontSize={"12px"} mt={1}>
            Pay Annually & save Rs. ###/Month
          </Text>
          <Flex gap={5} mt={1}>
            <Flex alignItems={"center"} fontSize={"12px"} gap={2}>
              <BsCircleFill color="white" size={14} /> Pay Monthly
            </Flex>
            <Flex alignItems={"center"} fontSize={"12px"} gap={2}>
              <BsCircleFill color="white" size={14} />
              Pay Annually
            </Flex>
          </Flex>
        </Box>
        <Box
          w={"24%"}
          h={300}
          borderRadius={10}
          bgImg={bgbox}
          bgRepeat={"no-repeat"}
          bgPosition={"center"}
          px={10}
        >
          <Flex justifyContent={"end"} pt={6}>
            <Image src={crown} w={20} />
          </Flex>
          <Text fontWeight={"bold"} fontSize={30} mt={-6}>
            Small
          </Text>
          <Text fontWeight={"bold"} fontSize={30} mt={-4}>
            Business Plan
          </Text>
          <Text lineHeight={1.1} fontSize={14} mt={3}>
            Select the plan that best meets your needs. Unleash all your gifting
            needs with the power of Wishfy
          </Text>
          <Flex alignItems={"center"} fontSize={"14px"} mt={5}>
            Know more <AiFillCaretRight color="#48f542" />
          </Flex>
        </Box>
        <Box w={"22%"}>
          <Flex alignItems={"baseline"}>
            <Text mt={6} fontSize={"24px"} fontWeight={"semibold"}>
              Corporate Plan
              <br />
              <Flex alignItems={"center"} fontSize={"14px"}>
                Know more <AiFillCaretRight color="#48f542" />
              </Flex>
            </Text>
            <Image src={uss} alt="error" w={14} />
          </Flex>
          <Divider border={"1px solid gray"} w={"95%"} mt={2} mb={2} />
          <Flex flexDirection={"column"}>
            <Text fontSize={"14px"} fontWeight={"semibold"}>
              Rs.399 Monthly
            </Text>
            <Text fontSize={"14px"} fontWeight={"semibold"}>
              Rs.4,200 Annually
            </Text>
          </Flex>
          <Text fontSize={"12px"} mt={1}>
            Pay Annually & save Rs. ###/Month
          </Text>
          <Flex gap={5} mt={1}>
            <Flex alignItems={"center"} fontSize={"12px"} gap={2}>
              <BsCircleFill color="white" size={14} /> Pay Monthly
            </Flex>
            <Flex alignItems={"center"} fontSize={"12px"} gap={2}>
              <BsCircleFill color="white" size={14} />
              Pay Annually
            </Flex>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
}
